module.exports = __webpack_public_path__ + "img/zhan2.96db66c0.png";